import React, { Component } from 'react';

import AdminLayout from './layout';

import { getExclPtnrsEntryById, deleteEntry, changeStatusExclPart, sendAdminMessage } from '../../API/FetchCall';

import { MOBILE_REGEX, URL_REGEX,IMGBASEURL } from '../../constant.js';

import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter } from 'reactstrap';

import previewfooter from '../../../src/assets/images/footerpreview.png';
import previewheader from '../../../src/assets/images/previewheader.png';

import headerimage from '../../../src/assets/images/headerimage.png';
import leftmenuimage from '../../../src/assets/images/leftmenuimage.png';
import rightmenuimage from '../../../src/assets/images/rightmenuimage.png';

class exclusiveParterView extends Component {

    constructor(props) {
        super(props);
        let qrystr = window.location.search;
        const urlParams = new URLSearchParams(qrystr);
        
        let id = urlParams.get('id');
 
        this.state = {
            sendMessage:false,
            detailedpreview:false,
            banners:'',
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }

        this.id = this.props.match.params.id ? this.props.match.params.id : '';
        
        this.exclusivePartnerShipEntryB2B(this.id);

    }

    async exclusivePartnerShipEntryB2B(id) {
 
        let req = JSON.stringify({
          id: id
        })
        getExclPtnrsEntryById(req).then(response => {

 
        if (response.status === 1) {
 
            const data = response.result;

            this.setState({approval_status:"Pending"});
            this.setState({login_id:data.login_id});
            this.setState({emailaddress:data.emailaddress});
            this.setState({approvedstatus:data.approved});
            this.setState({banners:(data.banners!=null)?data.banners:''});

            if(data.approved==1){
                this.setState({approval_status:"Approved"});
            }
            if(data.approved==2){
                this.setState({approval_status:"Disapproved"});
            }
            this.setState(response.result);

        }

        });
    }


    componentDidMount() {

        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);

    }

    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh')
    }

    sendNotePopup = () =>{
        this.setState({sendMessage:true});
    }

    approveit= () =>{

            let insData = JSON.stringify({
                login_id:this.state.login_id,
                approved:1
            });

            changeStatusExclPart(insData).then(response => {

             let toastr = '';   
             if(response.status===1){
                alert("Approved successfully");
             }else{
                alert("error disapproving");
             }

            });
    }


    disapproveit= () =>{

            let insData = JSON.stringify({
                login_id:this.state.login_id,
                approved:0
            });

            changeStatusExclPart(insData).then(response => {

             let toastr = '';   
             if(response.status===1){
                alert("Disapproved successfully");
             }else{
                alert("error disapproving");
                
             }

            });
    }


    sendaMessage = () => {
         
          let insData = JSON.stringify({
                login_id:this.state.login_id,
                message:this.state.message
          });

          sendAdminMessage(insData).then(response => {

             let toastr = '';   
             if(response.status===1){
                alert("Message is sent successfully");
                
             }else{
                alert("error sending a message");
                 
             }

          });

    }

    handleChange = (e) => {
      const propName = e.target.name;
      this.setState({ [e.target.name]: e.target.value });
    };


    cancelPop1 = () => {
    this.setState({
      sendMessage: false
    })
    }

    cancelPop2 = () => {
    this.setState({
      detailedpreview: false
    })
    }

    preview = () => {
        this.setState({ detailedpreview: true});
    }
    deleteEntry(i, e) {
      
        if(window.confirm("Are you sure?")){

            let req_c = JSON.stringify({
                camp_id: this.camp_id
            });
            let THIS = this;
            let toastr = '';
            deleteEntry(req_c).then(async res => {
                if (res.status === 1) {
                    alert(res.message)    ;
                    this.props.history.push('/users/exclusivepartners');

                }
            })

        }

    }

    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
 
    handleSubmit = (e) => {

        e.preventDefault();

        //console.log("nae1", e.target.program_name);
        
            let insData = {
                camp_id:this.camp_id,
                status:1
            }

            console.log('insData',insData);
              
 
    };



    render() {

   
        const { role, user_name } = this.state.auth_data;
        //console.log(this.state.banner);
        const { banners, banners_b2b}= this.state;
         //console.log(banners);
        const offer1 = IMGBASEURL+'uploads/'+this.state.offerimage1;
        const offer2 = IMGBASEURL+'uploads/'+this.state.offerimage2;

        return (
            <React.Fragment>
                <AdminLayout>
                    
             <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Exclusive Partnership Management - View/Manage</h4>
                    
                  <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                    <div className="tab-content">
                                        <div id="company-info" className="tab-pane in active">
                                            <form onSubmit={this.handleSubmit} className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no" method="post">
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        
                                                        <div className="form-group col-md-6">
                                                            <label>Name <span className="astrick">*</span></label>
                                                            <div>{this.state.name}</div>
                                                           
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label>Type <span className="astrick">*</span></label>
                                                            <div>{(this.state.optiontoshow=='both')?"B2B/B2C":(this.state.optiontoshow=='onlypartners')?"B2B":"B2C"}</div>
                                                           
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label>Address </label>
                                                            <div>{this.state.address}</div>
                                                           
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label>Email Address </label>
                                                            <div>{this.state.emailaddress}</div>
                                                           
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label>Website </label>
                                                            <div>{this.state.website}</div>
                                                           
                                                        </div>

                                                        <div className="form-group col-md-12">
                                                            <label>Description </label>
                                                             
                                                            <div dangerouslySetInnerHTML={{ __html: this.state.description_b2b }}></div>
                                                            
                                                        </div>
                                                         
                                                    </div>
                                                </div>
                      
                                                <div className="box-shadow-custom">
                                                <div className="row">
                                                <div className="col-md-12 col-xs-12">
                                                <span className="form-legend">Exclusive Offers</span>
                                                </div>

                                                <div class="containerrow">

                                                {(this.state.offerimage1==null || this.state.offerimage1=='') && 
                                                
                                                    <div class="offer_row borderwithcolor1">No offers entered</div>
                                                }

                                                {(this.state.offerimage1!=null && this.state.offerimage1!='') &&
                                                <div class="offer_row borderwithcolor1">
                                                <div class="offer_left_img" style={{width:"200px"}}><img src={IMGBASEURL+'uploads/'+this.state.offerimage1} /></div>
                                                <div class="offer_right_text"><div dangerouslySetInnerHTML={{ __html: this.state.offer1desc_b2b }}></div></div>
                                                </div>
                                                }

                                                </div>


                                                </div>
                                                </div>


                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Media Information</span>
                                                        </div>
                                                        
                                                        <div className="form-group col-md-6">
                                                            <label>Logo</label>
                                                            <div className="logoimg" style={{width:"200px"}}><img src={IMGBASEURL+'uploads/'+this.state.logo} /></div>
                                                        </div>
                                                       
                                                        <div className="form-group col-md-6">
                                                            <label>Banner</label>

                                                            
                                                            <div className="bannerimg" style={{width:"200px"}}>
                                                             
                                                             <img  style={{width:"100%"}} src={IMGBASEURL+'uploads/'+this.state.banners_b2b} />
                                                            
                                                            </div>
                                                            
                                                        </div>
                                                                                                            
                                                        <div className="form-group col-md-4">
                                                            <label>Brochure/Samples</label>
                                                            <div className="brochurefile">
                                                                
                                                                 <div>
                                                                 {(this.state.brochures_b2b!='' && this.state.brochures_b2b !=null) && (
                                                                     <a href={IMGBASEURL+'uploads/'+this.state.brochures_b2b} target="_blank">
                                                                         <img src={IMGBASEURL+'uploads/'+this.state.brochures_b2b_thumb} style={{width:"200px"}} className="fileicon" />
                                                                     </a>
                                                                 )}
                                                                 {(this.state.brochures_b2b=='' || this.state.brochures_b2b == null) && (
                                                                        <div>None Uploaded</div>
                                                                 )}  
                                                                 </div>
                                                                
                                                               
                                                                 
                                                            </div>
                                                        </div>
                   
                                                  
                                                    </div>
                                                </div>

                                            <div className="box-shadow-custom">
                                                <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Social Media</span>
                                                        </div>
                                                        
                                                        <div className="form-group col-md-6">
                                                            <label>Facebook</label>
                                                            <div className="logoimg">{this.state.facebook}</div>
                                                        </div>
                                                       
                                                        <div className="form-group col-md-6">
                                                            <label>Twitter</label>
                                                            <div className="bannerimg">{this.state.twitter}</div>
                                                        </div>
                                                                                                            
                                                        <div className="form-group col-md-4">
                                                            <label>Instagram</label>
                                                            <div className="brochurefile">
                                                             {this.state.instagram}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Linkedin</label>
                                                            <div className="brochurefile">
                                                             {this.state.linkedin}
                                                            </div>
                                                        </div>                  
                                                  
                                                    </div>
                                                </div>

                                               
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <b>Status :</b> {this.state.approval_status}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                <div className="col-md-6 col-xs-12">
                                                    <button id="btnSubmit1" className={(this.state.approvedstatus=='' || this.state.approvedstatus==0)? "btn btn-blue" : "btn btn-blue hidden"} onClick={this.approveit}>Approve</button>&nbsp;
                                                    <button id="btnSubmit2" className={(this.state.approvedstatus==2 || this.state.approvedstatus==0)? "btn btn-blue hidden" : "btn btn-blue"} onClick={this.disapproveit}>OnHold</button>&nbsp;
                                                    <button id="btnSubmit3" className={"btn btn-blue"} onClick={this.preview}>Preview</button>&nbsp;
                                                    <button id="btnSendNotes" className="btn btn-blue" onClick={this.sendNotePopup}>Send Message</button>&nbsp;
                                                    <button id="btnDelete" className="btn btn-blue" onClick={this.deleteEntry}>Delete</button>
                                                </div>


                                                 <div className="col-md-6 col-xs-12 text-right ">
                                                    <a href="/exclusive_partnerships">Back to List</a>
                                                </div>
                                                </div>
                                             </form>
                                        </div>
                                    </div>
                                </div>

                </div>
              </div>
            </div>  

            <Modal isOpen={this.state.sendMessage} className="modalpopup">
          <ModalHeader>Send a message</ModalHeader>
          <ModalBody className='p-0'>
            
              <div class="form-group">
                <label>To: </label> 
                <div><b>&nbsp;{this.state.name}</b></div>
                <div class="notemessage">Message will be sent to this email address :{this.state.emailaddress}</div>
              </div>
              <div class="form-group">
                <label>Message: </label>    
                <textarea name="message" class="form-control" rows="6" onChange={this.handleChange}></textarea>
              </div>      
              <div class="form-group">
                 <br/>
                 <button class="btn btn-primary btn-sm" onClick={this.sendaMessage}>Send</button>   
                    
              </div>  
          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop1}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>
        <Modal size="lg" isOpen={this.state.detailedpreview} className="modalpopup">
          <ModalHeader>Preview - Detail Page View</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>

                <div className="row">            
                    <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding">
                        <img src={headerimage} class="headerimagewidth" /> 
                    </div>
                </div>

                <div className="row">
                      
                  <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding">
                           
                      <div class="row">
                        <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding">
                          <div class="per20 logobox">
                            <img src={IMGBASEURL+"uploads/"+this.state.logo} class="orgphoto" />
                          </div>
                        </div>
                        <div class="col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding">
                          <a href="#" target="_blank"><img src={IMGBASEURL+"uploads/"+this.state.banners} class="bannerimage" /></a>
                        </div>
                      </div> 

                      <div class="row">
                          <div class="col-lg-2 leftmenu">
                          <img src={leftmenuimage} class="leftmenuimg" />
                          </div>

                          <div class="col-lg-8">

                                <div class="onDemandInfo" id="onDemandInfo">
                                  <div id="description_section"><h3>About Us</h3>
                                  <div class="aboutinfo" dangerouslySetInnerHTML={{__html:this.state.description}}></div>
                                  </div>
                                  <br/>
                                  <div id="exclusive_offers_section">
                                   <h3>Exclusive Offers</h3>
                                   <div class="offer_row borderwithcolor1">
                                    {this.state.offerimage1!='' && this.state.offerimage1!=null &&
                                    <div class="offer_left_img">
                                      <img src={"https://api.bewise.in/uploads/"+this.state.offerimage1} />
                                    </div>
                                    }
                                    <div class="offer_right_text">
                                        <div dangerouslySetInnerHTML={{__html:this.state.offer1desc}}></div>
                                    </div>
                                   </div>     
                                   {this.state.contenttype=='bewisecustom' && 
                                    <button name="participate" class="btn btn-primary">Participate</button> 
                                   }
                                    { /* clicktext  link */ }
                                   {this.state.contenttype=='href' && 
                                     <div><a href={this.state.link}>{this.state.clicktext}</a></div>
                                   }
                                   {this.state.contenttype=='btn' && 
                                     <div><a href={this.state.link} class="btn btn-primary btn-sm">{this.state.clicktext}</a></div>
                                   }
 

                                  </div>
                                  <br/>
                                  <div id="video_section"><h3>Videos</h3>
                                  <div class="row n5v3k">
                                        {this.state.video!='' && this.state.video!=null && 
                                        <div class="container">
                                              <video width="320" height="240" controls>
                                                  <source src={this.state.video} type="video/mp4" />
                                                   Your browser does not support the video tag.
                                              </video>
                                        </div>
                                        }
                                        {this.state.videourl!=='' && this.state.videourl!=null &&  
                                        <div class="container">
                                            <iframe width="420" height="315" src={"https://www.youtube.com/embed/"+this.state.videourl}>
                                            </iframe>
                                        </div>
                                        }
                                  </div>
                                  </div>
                                  <br/>
                                  <div id="contactinfo_section"><h3>Contact Info</h3>
                                  <div class="col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left">
                                    <div class="per100 text-left">
                                      <div class="bs_social">
                                        <div> Email Address: <b>{this.state.emailaddress}</b> </div><br/>
                                        <div> Website: <b><a target="_blank" href={this.state.website}>{this.state.website}</a></b> </div>
                                        <br/>
                                        <div> Contact Number: <b>{this.state.contact_number}</b> </div><br/>
                                        
                                        </div>
                                        </div>
                                      </div>
                                      </div>
                                      <br/>
                                         <div id="review_section"><h3 class="review_head">Review<div class="floatright"><small class="pointer"><i class="fa fa-plus" aria-hidden="true"></i></small></div></h3>
                                          <div class="reviewinfo">
                                            <div class="col-md-12">
                                              <div class="detailBox">
                                                <div class="form-comments"><p>Click here to view Comments!...</p></div>
                                                </div>
                                                </div>
                                                </div>
                                                </div>
                                                <br/>
                                          </div>


                          </div>

                          <div class="col-lg-2 rightmenu">

                          <img src={rightmenuimage} class="rightmenuimg" />
                          </div>
                      </div>  

                    
                  </div>



                </div>

                <div class="row">
                  <div class="col-md-12 footerp">
                    <img src={previewfooter} class="headerimagewidth"/>
                  </div>
                </div>
          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop2}>Close</button>
              </div>
            </div>

          </ModalFooter>
  </Modal>             
 
                </AdminLayout>
            </React.Fragment>
        )
    }
}



export default exclusiveParterView;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveParterViewB2B.jsx